import { Box, TextField, IconButton } from "@mui/material";
import { EEslTemplateElementType } from "../../../../models/enums/eslTemplateType";
import IEslTemplateItem from "../../../../models/esl/eslTemplateElement";
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import { useTranslation } from "react-i18next";
import EslColorPalette from "../../../../components/esl/EslColorPalette";

interface ITextElementPropretiesProps {
  selectedElement: IEslTemplateItem;
  onUpdateElement: (element: IEslTemplateItem) => void;
}

const TextElementPropreties = ({ selectedElement, onUpdateElement }: ITextElementPropretiesProps) => {
  const { t } = useTranslation(['eslTemplate', 'common']);

  return (
    <Box>
      <TextField
        label={t('eslTemplate:templateEditor.elementPropreties.content')}
        name="content"
        value={selectedElement.textContent}
        onChange={(e) => onUpdateElement({ ...selectedElement, textContent: e.target.value })}
        fullWidth
        multiline={selectedElement.type === EEslTemplateElementType.MultilineText}
      />

      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <TextField
          label={t('eslTemplate:templateEditor.elementPropreties.fontSize')}
          name="fontSize"
          type="number"
          value={selectedElement.style.fontSize}
          fullWidth
          onChange={(e) => {
            const fontSizeRegex = /^[0-9\b]+$/;
            if (e.target.value === '' || fontSizeRegex.test(e.target.value)) {
              onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, fontSize: Number(e.target.value) } });
            }
          }}
        />
        <EslColorPalette selectedColor={selectedElement.style.color} onColorSelect={(color) => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, color } })} />
      </Box>

      <Box sx={{ mt: 2, display: "flex", justifyContent: 'space-evenly' }}>
        <IconButton sx={{ backgroundColor: selectedElement.style.isBold ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, isBold: !selectedElement.style.isBold } })}>
          <FormatBoldIcon />
        </IconButton>
        <IconButton sx={{ backgroundColor: selectedElement.style.isItalic ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, isItalic: !selectedElement.style.isItalic } })}>
          <FormatItalicIcon />
        </IconButton>
        <IconButton sx={{ backgroundColor: selectedElement.style.isUnderline ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, isUnderline: !selectedElement.style.isUnderline } })}>
          <FormatUnderlinedIcon />
        </IconButton>
      </Box>

      {selectedElement.type === EEslTemplateElementType.MultilineText && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: 'space-evenly' }}>
          <IconButton sx={{ backgroundColor: selectedElement.style.textAlign === "left" ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, textAlign: "left" } })}>
            <FormatAlignLeftIcon />
          </IconButton>
          <IconButton sx={{ backgroundColor: selectedElement.style.textAlign === "center" ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, textAlign: "center" } })}>
            <FormatAlignCenterIcon />
          </IconButton>
          <IconButton sx={{ backgroundColor: selectedElement.style.textAlign === "right" ? "rgba(0, 0, 0, 0.1)" : "" }} onClick={() => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, textAlign: "right" } })}>
            <FormatAlignRightIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export default TextElementPropreties;